/** Locales the UI is translated to. To add one: create src/locales/<code>.json and list it here. */
export const availableLocales = [
  { code: "ru", name: "Русский" },
  { code: "en", name: "English" },
]

export const LOCALE_STORAGE_KEY = "locale"

const isAvailable = (code) => availableLocales.some((l) => l.code === code)

/** Returns the saved locale, or the browser language if it is available, or English */
export const getInitialLocale = () => {
  let saved = null
  try {
    saved = localStorage.getItem(LOCALE_STORAGE_KEY)
  } catch (e) {}
  if (saved && isAvailable(saved)) return saved

  const browserLanguages =
    typeof navigator !== "undefined"
      ? navigator.languages ?? [navigator.language]
      : []
  for (const lang of browserLanguages) {
    const code = lang?.slice(0, 2).toLowerCase()
    if (isAvailable(code)) return code
  }
  return "en"
}
